import Repo from './Repo.js'

export default class WarehouseRepository extends Repo {
  constructor () {
    super('warehouses')
  }

  all (q, include) {
    return super.all(q, {include: include})
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
    return super.paginate(q)
  }

  getControllers(id, include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource + '/' + id + '/controllers', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  attachController(id, controller_id){
    return this.http.post(this.resource + '/' + id + '/controllers/' + controller_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  detachController(id, controller_id){
    return this.http.delete(this.resource + '/' + id + '/controllers/' + controller_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getTransactions(id, include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource + '/' + id + '/warehouse-transactions', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getStates(id, data) {
    return this.http.get(this.resource + '/' + id + '/warehouse-states', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  productMove(data) {
    return this.http.post(this.resource + '/move', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
